import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import getLoginId from '../../../../utils/getLoginId'
import Loader from '../../../common/Loader'
import Button from '@material-ui/core/Button'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import withSharedSnackbar from '../../../HOCs/withSharedSnackbar'
import EditDevice from './EditDevice'
import getAccountType from '../../../../utils/getAccountType.js'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

const GET_DEVICE_LIST_BASIC = gql`
  query getAllDeviceDetailsByLoginId(
    $loginId: Int!
    $accountType: String!
    $deviceModelId: Int!
  ) {
    devices: getAllDeviceDetailsByLoginId(
      loginId: $loginId
      accountType: $accountType
      deviceModelId: $deviceModelId
    ) {
      serial_num
      imei_num
      uniqueDeviceId
      status
    }
  }
`

const GET_DEVICE_LIST_WITH_DETAILS = gql`
  query getAllDeviceDetailsByLoginId(
    $loginId: Int!
    $accountType: String!
    $deviceModelId: Int!
  ) {
    devices: getAllDeviceDetailsByLoginId(
      loginId: $loginId
      accountType: $accountType
      deviceModelId: $deviceModelId
    ) {
      serial_num
      imei_num
      uniqueDeviceId
      status
      clientName
      vehicleDetail {
        vehicleNumber
      }
    }
  }
`

class ViewInventoryDevices extends Component {
  constructor(props) {
    super(props)
    this.classes = props
  }
  clientId = []

  getColumns = () => {
    if (this.state.includeClientVehicleDetails) {
      return [
        'SERIAL NO',
        'IMEI NO',
        'UNIQUE ID',
        'STATUS',
        'VEHICLE NO',
        'CLIENT NAME',
        'PARTNER NAME'
      ]
    } else {
      return [
        'SERIAL NO',
        'IMEI NO',
        'UNIQUE ID',
        'STATUS',
        'PARTNER NAME'
      ]
    }
  }

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 25,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      console.log(this.status[dataIndex.dataIndex], 'di')
      if (this.status[dataIndex.dataIndex] === 2) {
        this.editDevice(this.uniqueDeviceId[dataIndex.dataIndex])
      } else {
        this.props.openSnackbar('Device cannot be edited')
      }
    }
  }
  state = {
    open: false,
    open1: false,
    openEdit: false,
    selUniqueDeviceId: '',
    devicesData: [],
    loading: false, // Changed to false initially so we don't show loader before dialog choice
    fetchOptionsDialogOpen: false,
    includeClientVehicleDetails: false
  }

  componentDidMount = () => {
    // Check if we have state passed from previous page
    if (this.props.location.state && typeof this.props.location.state.includeClientVehicleDetails !== 'undefined') {
      this.setState({
        includeClientVehicleDetails: this.props.location.state.includeClientVehicleDetails,
        loading: true
      }, () => {
        this.fetchDevicesData()
      })
    } else {
      // Fallback: show dialog if accessed directly (though typically it should come from the listing page)
      this.setState({ fetchOptionsDialogOpen: true })
    }
  }

  editDevice = uniqueDeviceId => {
    // console.log(uniqueDeviceId, 'demo')
    this.setState({ selUniqueDeviceId: uniqueDeviceId }, () => {
      console.log(this.state.selUniqueDeviceId, 'uid')
    })
    this.handleClickOpen()
  }
  handleClickOpen = () => {
    this.setState({ openEdit: true })
  }
  handleClose = async () => {
    console.log('Cancel')
    await this.fetchDevicesData()
    this.setState({ openEdit: false, open: false })
  }
  mapToArr(devices) {
    var rowData = []
    var fullData = []
    this.status = []
    this.uniqueDeviceId = []
    devices.forEach(element => {
      rowData = []
      this.status.push(element.status)
      this.uniqueDeviceId.push(element.uniqueDeviceId)
      rowData.push(element.serial_num)
      rowData.push(element.imei_num)
      rowData.push(element.uniqueDeviceId)
      rowData.push(this.getStatus(element.status))
      if (this.state.includeClientVehicleDetails) {
        element.vehicleDetail
          ? rowData.push(element.vehicleDetail.vehicleNumber)
          : rowData.push('N/A')
        element.clientName
          ? rowData.push(element.clientName)
          : rowData.push('N/A')
      }
      rowData.push('Taabi Mobility Private Limited')
      fullData.push(rowData)
    })
    // console.log(this.status, this.uniqueDeviceId, 'jj')
    return fullData
  }
  getStatus = status => {
    if (status === 2) {
      return 'Instock'
    } else if (status === 3) {
      return 'Assigned to Client'
    } else if (status === 4) {
      return 'Registered to vehicle'
    }
  }
  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleCloseFetchOptionsDialog = () => {
    this.setState({
      fetchOptionsDialogOpen: false
    })
    this.props.history.goBack()
  }

  handleFetchData = () => {
    this.setState({
      fetchOptionsDialogOpen: false,
      loading: true
    }, () => {
      this.fetchDevicesData()
    })
  }

  // handleClose = () => {
  //   this.setState({ open: false }, this.fetchDevicesData())
  // }
  handleClickBulkOpen = () => {
    this.setState({ open1: true })
  }

  handleBulkClose = () => {
    this.setState({ open1: false })
  }
  addBulkUpload = e => {
    this.props.history.push({
      pathname: '/home/DeviceInventory/BulkUpload'
    })
  }
  assignBulkUpload = e => {
    console.log('bulk')
    this.props.history.push({
      pathname: '/home/DeviceInventory/BulkDeviceAssign'
    })
  }

  fetchDevicesData = async () => {
    console.log('Called')
    const query = this.state.includeClientVehicleDetails
      ? GET_DEVICE_LIST_WITH_DETAILS
      : GET_DEVICE_LIST_BASIC

    let {
      loading,
      error,
      data: { devices }
    } = await this.props.client.query({
      query: query,
      variables: {
        loginId: getLoginId(),
        accountType: localStorage.getItem('Account_type'),
        deviceModelId: parseInt(this.props.match.params.modelId, 10)
      },
      fetchPolicy: 'network-only'
    })
    this.setState({ devicesData: this.mapToArr(devices), loading: false })
  }


  render() {
    const { classes } = this.props
    let { loading, devicesData } = this.state

    return (
      // <Query
      //   query={GET_DEVICE_LIST}
      //   variables={{
      //     loginId: getLoginId(),
      //     accountType: localStorage.getItem('Account_type'),
      //     deviceModelId: parseInt(this.props.match.params.modelId, 10)
      //   }}
      //   fetchPolicy="network-only"
      // >
      //   {({ loading, error, data: { devices } }) => {
      //     if (loading) return <Loader />
      //     if (error) return `Error!: ${error}`

      //     const data = this.mapToArr(devices)
      //     // console.log('devices', devices)
      //     return (

      <div>
        {loading ? (
          <Loader />
        ) : (
          <div className={classes.root}>
          
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              {/* <AddDevice handleClose={this.handleClose} /> */}
            </Dialog>
            <Grid container spacing={16} direction="row">
              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  color="secondary"
                  className={classes.button}
                  onClick={() => this.props.history.goBack()}
                >
                  <ArrowBackIcon className={classes.iconSmall} />
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="headline">Device Details</Typography>
              </Grid>
              <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
              >
                {
                  <EditDevice
                    handleClose={this.handleClose}
                    selUniqueDecviceId={this.state.selUniqueDeviceId}
                    fetchDevicesData={this.fetchDevicesData}
                  />
                }
              </Dialog>

              <Grid item xs={12}>
                {/* TODO: Replace this with a custom table going forward */}
                <MUIDataTable
                  data={devicesData}
                  columns={this.getColumns()}
                  options={this.options}
                />
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(ViewInventoryDevices))
)



// WEBPACK FOOTER //
// ./src/components/Pages/InventoryDevices/ViewInventoryDevices/index.jsx